import { datadogRum } from '@datadog/browser-rum';

if (window.Greenhouse && window.Greenhouse.DatadogRum) {
  datadogRum.init({
    clientToken: window.Greenhouse.DatadogRum.clientToken,
    applicationId: window.Greenhouse.DatadogRum.applicationId,
    site: window.Greenhouse.DatadogRum.site,
    env: window.Greenhouse.DatadogRum.env,
    service: window.Greenhouse.DatadogRum.service,
    version: window.Greenhouse.DatadogRum.version,
    sessionSampleRate: window.Greenhouse.DatadogRum.sampleRate,
    traceSampleRate: window.Greenhouse.DatadogRum.tracingSampleRate,
    trackInteractions: window.Greenhouse.DatadogRum.trackInteractions,
    trackFrustrations: window.Greenhouse.DatadogRum.trackFrustrations,
    trackResources: window.Greenhouse.DatadogRum.trackResources,
    trackLongTasks: window.Greenhouse.DatadogRum.trackResources,
    allowedTracingOrigins: [
      /*
        Allow RUM <> APM distributed tracing for all greenhouse domains except boards.greenhouse.io
        due to additional request headers that get added to internal job boards.
      */
      /https:\/\/.*\.greenhouse\.(io|dev)/,
    ],
  });

  datadogRum.setRumGlobalContext(window.Greenhouse.DatadogRum.requestContext);
}
